import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "inner-modal inner-modal--acc" }
const _hoisted_2 = { class: "acc" }
const _hoisted_3 = { class: "acc__inner" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "acc__wishlist" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "acc__wishlist-kicker" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "svg-inline--fa fa-heart cta-icon-left",
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "fasr",
      "data-icon": "heart",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        class: "",
        fill: "currentColor",
        d: "M256 163.9L222.1 130l-24.2-24.2C181.4 89.3 159 80 135.8 80C87.3 80 48 119.3 48 167.8c0 23.3 9.2 45.6 25.7 62.1l24.2 24.2L256 412.1 414.1 254.1l24.2-24.2c16.5-16.5 25.7-38.8 25.7-62.1c0-48.5-39.3-87.8-87.8-87.8c-23.3 0-45.6 9.2-62.1 25.7L289.9 130 256 163.9zm33.9 282.2L256 480l-33.9-33.9L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c0 0 0 0 0 0c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 36-14.3 70.5-39.8 96L448 288 289.9 446.1z"
      })
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "acc__wishlist-add" }, "Add to Wishlist")
  ])
], -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "acc__wishlist-head" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "acc__wishlist-heading" }, "Your Design")
], -1 /* HOISTED */)
const _hoisted_6 = { class: "text-danger text-center" }
const _hoisted_7 = {
  key: 1,
  class: "acc__wishlist-list"
}
const _hoisted_8 = { class: "acc__wishlist-card" }
const _hoisted_9 = { class: "acc__wishlist-image-col" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "acc__wishlist-content-col" }
const _hoisted_12 = { class: "acc__wishlist-content-heading" }
const _hoisted_13 = { class: "acc__wishlist-model-number" }
const _hoisted_14 = { class: "acc__wishlists-container" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "acc__wishlist-container-col-1" }, "Add All To:", -1 /* HOISTED */)
const _hoisted_16 = { class: "acc__wishlist-container-col-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  selected: "",
  value: ""
}, "Select a Wishlist", -1 /* HOISTED */)
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "invalid-feedback" }
const _hoisted_20 = {
  key: 1,
  class: "acc__wishlist-new"
}
const _hoisted_21 = { class: "acc__wishlist-new-col-1" }
const _hoisted_22 = { class: "invalid-feedback" }
const _hoisted_23 = { class: "acc__wishlist-new-col-2" }
const _hoisted_24 = {
  key: 0,
  class: "acc__wishlist-new-col-3"
}
const _hoisted_25 = {
  key: 0,
  class: "acc__wishlist-container-col-3"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "acc__disclaimer" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Note:"),
  /*#__PURE__*/_createTextVNode(" Products shown are for inspiration purposes only, all product selections should be verified by a professional at one of our showrooms before ordering to ensure proper fit and that all parts will function properly together. You may locate the nearest showroom to you by visiting "),
  /*#__PURE__*/_createElementVNode("a", { href: "//www.baldwinhardware.com/where-to-buy" }, "www.baldwinhardware.com/where-to-buy")
], -1 /* HOISTED */)

import {ref, watchEffect, watch} from 'vue';
import {WishlistItemsToAdd, WishlistItemsAdd, WishlistItems, WishlistItemDelete} from "Api/apis";
import { useStore } from 'vuex';
import Cta from "Vue/components/lockDesigner/components/shared/Cta.vue";
import {useToast} from 'vue-toastification';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const componentName = 'AddToWishlistModal';
const store = useStore();
const wishlistItems = ref([]);
const wishlists = ref([]);
const selectedWishlist = ref('');
const newWishlistName = ref('');
const addMode = ref<boolean>(false);
const validationErrors = ref<string[]>([]);
const formValidationErrors = ref<any>({});
const toast = useToast();

watchEffect(async () => {
	const lockDesignerWishlistItemsToAddRequest = {
		selections: store?.state?.selections,
		wishlistName: ''
	};
	const authToken = store?.state?.authToken;
	let items = await WishlistItemsToAdd(lockDesignerWishlistItemsToAddRequest, authToken);
	wishlistItems.value = items.data?.components || [];
	wishlists.value = items.data?.wishlists || [];

	if(!wishlists.value.length) {
		addMode.value = true;
	}
});


const addToWishlist = async(wishlistName) => {
	const lockDesignerWishlistItemsToAddRequest = {
		selections: store?.state?.selections,
		wishlistName: wishlistName
	};
	let response = await WishlistItemsAdd(lockDesignerWishlistItemsToAddRequest, store?.state?.authToken);
	if(response.data) {
		formValidationErrors.value = {};
		await toast.success(`You successfully saved your items to your wishlist`, {
			timeout: 2000
		});
		await store.dispatch('closeModal');
	} else {
		if(response.isErrors) {
			if(response.errorDetail.isError) {
				validationErrors.value = response.userFriendlyMessages;
			}
			if(response.formValidationMessages) {
				formValidationErrors.value = response.formValidationMessages;
			}
		} else {
			formValidationErrors.value = {};
		}
	}
}

watch(addMode, (newValue, oldValue) => {
	formValidationErrors.value = {};
});

const closeModal = async() => {
	await store.dispatch('closeModal');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        (validationErrors.value.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(validationErrors.value, (error) => {
              return (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(error), 1 /* TEXT */))
            }), 256 /* UNKEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        (wishlistItems.value.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wishlistItems.value, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  class: "acc__wishlist-item"
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("img", {
                        src: item.imageUrl,
                        class: "acc__wishlist-image"
                      }, null, 8 /* PROPS */, _hoisted_10)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(item.description), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_13, "Model Number: " + _toDisplayString(item.modelNumber), 1 /* TEXT */)
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            (wishlists.value.length && !addMode.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _withDirectives(_createElementVNode("select", {
                    name: "wishlistSelection",
                    id: "wishlistSelection",
                    class: _normalizeClass([`form-control`, formValidationErrors.value?.wishlistName?.length ? 'is-invalid' : '']),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedWishlist).value = $event))
                  }, [
                    _hoisted_17,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wishlists.value, (wishlist) => {
                      return (_openBlock(), _createElementBlock("option", { value: wishlist }, _toDisplayString(wishlist), 9 /* TEXT, PROPS */, _hoisted_18))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 2 /* CLASS */), [
                    [_vModelSelect, selectedWishlist.value]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formValidationErrors.value?.wishlistName, (error) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_19, " • " + _toDisplayString(error), 1 /* TEXT */))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            (addMode.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "wishlistName",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newWishlistName).value = $event)),
                      class: _normalizeClass([`form-control`, formValidationErrors.value?.wishlistName?.length ? 'is-invalid' : '']),
                      placeholder: "Enter Wishlist Name"
                    }, null, 2 /* CLASS */), [
                      [_vModelText, newWishlistName.value]
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formValidationErrors.value?.wishlistName, (error) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_22, " • " + _toDisplayString(error), 1 /* TEXT */))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(Cta, {
                      type: "outline",
                      size: "lg",
                      label: "Add",
                      onOnClick: _cache[2] || (_cache[2] = ($event: any) => (addToWishlist(newWishlistName.value))),
                      icon: [],
                      iconAlignment: "right"
                    })
                  ]),
                  (wishlists.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createVNode(Cta, {
                          type: "primary",
                          size: "lg",
                          label: "Cancel",
                          onOnClick: _cache[3] || (_cache[3] = ($event: any) => (addMode.value = !addMode.value)),
                          icon: [],
                          iconAlignment: "left"
                        })
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          (wishlists.value.length && !addMode.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createVNode(Cta, {
                  type: "outline",
                  size: "lg",
                  label: "Add",
                  onOnClick: _cache[4] || (_cache[4] = ($event: any) => (addToWishlist(selectedWishlist.value))),
                  icon: [],
                  iconAlignment: "right"
                }),
                _createVNode(Cta, {
                  type: "primary",
                  size: "lg",
                  label: "Create New",
                  onOnClick: _cache[5] || (_cache[5] = ($event: any) => (addMode.value = !addMode.value)),
                  icon: ['fasr', 'fa-plus'],
                  iconAlignment: "left"
                })
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _hoisted_26
      ])
    ]),
    _createElementVNode("button", {
      onClick: closeModal,
      class: "inner-modal__close"
    }, "×")
  ]))
}
}

})